import React from 'react';
import Contents from '../../components/Contents';
import PageLayout from '../../ui/layout/PageLayout';
import './styles.css';

function ContentsPage() {
  return (
    <PageLayout title="Conteúdos" subtitle="Biblioteca e edição" primary={<Contents />} secondary={null} />
  );
}

export default ContentsPage;
